import axios from 'axios';
import { AuthService } from './auth.service';
import { ENDPOINTS } from '../constants/endpoints';
import { DocumentRequirement, LeaveTypeConfig } from '../interfaces/leave.interface';
import { UpdateLeaveTypeAccrualSettingsRequest } from '../interfaces/leaveAccrual.interface';

export const LeaveTypeService = {
    getByInstitution: async (activeOnly = false): Promise<LeaveTypeConfig[]> => {
        const institutionId = AuthService.getSelectedInstitution()!!;
        const response = await axios.get(ENDPOINTS.LEAVE_TYPE.BY_INSTITUTION(institutionId), {
            headers: AuthService.getAuthHeader()
        });
        const data: LeaveTypeConfig[] = response.data;
        return activeOnly ? data.filter(lt => lt.isActive !== false) : data;
    },

    create: async (
        name: string,
        documentRequirement: DocumentRequirement = DocumentRequirement.NONE,
        isPaid: boolean = true,
        encashable: boolean = false,
        minimumTenureMonths: number | null = null,
        attendanceBonusExempt: boolean = false
    ): Promise<LeaveTypeConfig> => {
        const institutionId = AuthService.getSelectedInstitution()!!;
        const response = await axios.post(ENDPOINTS.LEAVE_TYPE.BASE, {
            institutionId, name, documentRequirement, isPaid, encashable, minimumTenureMonths, attendanceBonusExempt
        }, {
            headers: AuthService.getAuthHeader()
        });
        return response.data;
    },

    updateDocumentRequirement: async (id: string, documentRequirement: DocumentRequirement): Promise<LeaveTypeConfig> => {
        const response = await axios.patch(ENDPOINTS.LEAVE_TYPE.UPDATE_DOC_REQUIREMENT(id), { documentRequirement }, {
            headers: AuthService.getAuthHeader()
        });
        return response.data;
    },

    updatePaidStatus: async (id: string, isPaid: boolean): Promise<LeaveTypeConfig> => {
        const response = await axios.patch(ENDPOINTS.LEAVE_TYPE.UPDATE_PAID(id), { isPaid }, {
            headers: AuthService.getAuthHeader()
        });
        return response.data;
    },

    setActiveStatus: async (id: string, isActive: boolean): Promise<LeaveTypeConfig> => {
        const response = await axios.patch(ENDPOINTS.LEAVE_TYPE.SET_ACTIVE(id), { isActive }, {
            headers: AuthService.getAuthHeader()
        });
        return response.data;
    },

    updateEncashableStatus: async (id: string, encashable: boolean): Promise<LeaveTypeConfig> => {
        const response = await axios.patch(ENDPOINTS.LEAVE_TYPE.UPDATE_ENCASHABLE(id), { encashable }, {
            headers: AuthService.getAuthHeader()
        });
        return response.data;
    },

    updateAccrualSettings: async (
        id: string,
        request: UpdateLeaveTypeAccrualSettingsRequest
    ): Promise<LeaveTypeConfig> => {
        const response = await axios.patch(ENDPOINTS.LEAVE_TYPE.UPDATE_ACCRUAL(id), request, {
            headers: AuthService.getAuthHeader()
        });
        return response.data;
    },

    updateMinimumTenureMonths: async (id: string, minimumTenureMonths: number | null): Promise<LeaveTypeConfig> => {
        const response = await axios.patch(ENDPOINTS.LEAVE_TYPE.UPDATE_MINIMUM_TENURE_MONTHS(id), { minimumTenureMonths }, {
            headers: AuthService.getAuthHeader()
        });
        return response.data;
    },

    updateAttendanceBonusExempt: async (id: string, attendanceBonusExempt: boolean): Promise<LeaveTypeConfig> => {
        const response = await axios.patch(ENDPOINTS.LEAVE_TYPE.UPDATE_ATTENDANCE_BONUS_EXEMPT(id), { attendanceBonusExempt }, {
            headers: AuthService.getAuthHeader()
        });
        return response.data;
    }
};
